export const numberRegex = new RegExp("[0-9]*");

export const emailRegex = new RegExp("[^@]+@[^@]+\.[^@]+");

export const widthNumToString = (widthNum: number | undefined): string => {
  return widthNum ? `${widthNum}rem` : "";
}
